





























import Vue from "vue";
import { Trophy } from "@tt-app/models";

import IconIncorrect from "@joyz/app-core/assets/icons/Incorrect.svg";
import IconCheckCircleActive from "@joyz/app-core/assets/icons/active/CheckCircle.svg";
import IconCorrect from "@joyz/app-core/assets/icons/Correct.svg";
import IconSkip from "@joyz/app-core/assets/icons/misc/DrillSkip.svg";
import TrophyGold from "@joyz/app-core/assets/trophy/achievements/Gold.svg";
import TrophySilver from "@joyz/app-core/assets/trophy/achievements/Silver.svg";
import TrophyBronze from "@joyz/app-core/assets/trophy/achievements/Bronze.svg";

interface Data {
  icons: {
    [key: string]: string;
  };
  trophies: string[];
}

interface Computed {
  comment: string;
  trophyEffectiveUrl: string;
}

interface Props {
  practiceMode: boolean;
  trophy: Trophy;
}

export default Vue.extend<Data, unknown, Computed, Props>({
  name: "ExerciseTrophy",

  props: {
    practiceMode: {
      type: Boolean,
      default: false
    },
    trophy: {
      type: Object,
      default: undefined
    }
  },

  data() {
    return {
      icons: {
        checkCircle: IconCheckCircleActive,
        correct: IconCorrect,
        incorrect: IconIncorrect,
        skip: IconSkip
      },
      trophies: ["", TrophyBronze, TrophySilver, TrophyGold]
    };
  },

  computed: {
    comment() {
      if (this.practiceMode) {
        return "";
      }

      return this.trophy.comment;
    },
    trophyEffectiveUrl(): string {
      if (this.practiceMode) return this.icons.checkCircle;

      return this.trophies[this.trophy?.score];
    }
  }
});
